import * as yup from 'yup';
import { puzzleNameValidator } from 'validations/string';
import { Status } from 'shared/enums';
import { getEventsPuzzlesParticipateIn } from 'services/utility/puzzles/events';

import { strings } from '../strings';

import { isAllowedToBeInSpecialCollection } from './puzzle';

export enum EditPuzzleField {
  Name = 'Name',
  Keywords = 'keywords',
  Publisher = 'Publisher',
  Collection = 'collection',
  SecondaryCollection = 'SecondaryCollection',
  PhysicalDistribution = 'physicalDistribution',
  AIGenerated = 'aiGenerated',
  Status = 'status',
  PremiumTier = 'premiumTier',
  RejectMessage = 'rejectMessage',
  ForceSetPublishDate = 'forceSetPublishDate',
}

export const editPuzzleShema = (puzzleId?: string) =>
  yup.object().shape({
    [EditPuzzleField.Name]: puzzleNameValidator(),
    [EditPuzzleField.Keywords]: yup.string().trim().required(strings.collectionKeywordsRequired),
    [EditPuzzleField.Publisher]: yup.object({
      label: yup.string(),
      value: yup.string().required(strings.collectionIsRequired),
    }),
    [EditPuzzleField.Collection]: yup
      .object({
        label: yup.string(),
        value: yup.string().required(strings.collectionIsRequired),
      })
      .required(strings.collectionIsRequired),
    [EditPuzzleField.SecondaryCollection]: yup
      .object({
        label: yup.string(),
        value: yup.string().required('Category id missing'),
      })
      .nullable(),
    [EditPuzzleField.PhysicalDistribution]: yup.boolean().required(),
    [EditPuzzleField.AIGenerated]: yup.boolean().required(),
    [EditPuzzleField.Status]: yup
      .object({
        label: yup.string(),
        value: yup.string().required(strings.collectionIsRequired),
      })
      .test('isAllowToBeInSpecialCategory', 'Not allowed category set', async (option, context) => {
        if (!puzzleId) return true;

        const optionValue = option.value as Status;

        return isAllowedToBeInSpecialCollection({
          status: optionValue,
          collections: [
            context.parent[EditPuzzleField.Collection]?.value,
            context.parent[EditPuzzleField.SecondaryCollection]?.value,
          ],
        });
      })
      .test('inActiveEvent', 'Puzzle is currently in active event', async (option, context) => {
        if (!puzzleId) return true;

        const optionValue = option.value;
        const checkStatuses: string[] = [
          Status.Deleted,
          Status.Disabled,
          Status.Pending,
          Status.Rejected,
        ];
        if (checkStatuses.includes(optionValue)) {
          const events = await getEventsPuzzlesParticipateIn(puzzleId);
          if (events.length > 0) {
            const eventsString = events.map((event) => event.event.id).join(', ');
            return context.createError({
              message: `Puzzle is part of events: ${eventsString}`,
            });
          }
        }

        return true;
      }),
    [EditPuzzleField.RejectMessage]: yup.string().when(EditPuzzleField.Status, {
      is: (status: { label: string; value: string }) => status.value === Status.Rejected,
      then: () => yup.string().required('Rejection message is required.'),
      otherwise: () => yup.string(),
    }),
  });
